import { useEffect, useState } from 'react'
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { api } from '../../api/client'
import { useAuth } from '../../contexts/AuthContext'

interface StoreProfile {
  id: string
  name: string
}

export function StoreAdminLayout() {
  const { user, logout } = useAuth()
  const [store, setStore] = useState<StoreProfile | null>(null)
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    api.get<StoreProfile>('/api/store/me')
      .then(setStore)
      .catch(() => {})
  }, [])

  const tabs = [
    { path: '/mi-tienda', label: '📊 Resumen', exact: true },
    { path: '/mi-tienda/productos', label: '📦 Productos', exact: false },
    { path: '/mi-tienda/pedidos', label: '🛒 Pedidos', exact: false },
  ]

  function isTabActive(path: string, exact: boolean) {
    if (exact) return location.pathname === path
    return location.pathname.startsWith(path)
  }

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="sidebar-brand">
          🔧 <span>{store?.name ?? 'Mi Ferretería'}</span>
        </div>
        <nav className="sidebar-nav">
          <NavLink
            to="/mi-tienda"
            end
            className={({ isActive }) => `sidebar-item${isActive ? ' active' : ''}`}
          >
            📊 Resumen
          </NavLink>
          <NavLink
            to="/mi-tienda/productos"
            className={({ isActive }) => `sidebar-item${isActive ? ' active' : ''}`}
          >
            📦 Productos
          </NavLink>
          <NavLink
            to="/mi-tienda/pedidos"
            className={({ isActive }) => `sidebar-item${isActive ? ' active' : ''}`}
          >
            🛒 Pedidos
          </NavLink>
        </nav>
        <div className="sidebar-footer">
          <span className="sidebar-user">{user?.fullName}</span>
          <button type="button" className="btn btn-ghost btn-sm" onClick={logout}>Salir</button>
        </div>
      </aside>
      <main className="admin-main">
        {/* Mobile tab bar */}
        <div className="tab-bar">
          {tabs.map(tab => (
            <button
              key={tab.path}
              type="button"
              className={`tab-bar-item${isTabActive(tab.path, tab.exact) ? ' tab-bar-item--active' : ''}`}
              onClick={() => navigate(tab.path)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <Outlet />
      </main>
    </div>
  )
}
